import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import reportWebVitals from './reportWebVitals';
import router from "./router";
import {ContextProvider} from "./contexts/ContextProvider";
import {CartProvider} from "./contexts/CartContext";
import {CookieConsentProvider} from "./contexts/CookieConsentContext";
import {RouterProvider} from "react-router-dom";
import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://10e517f660ad4c194788eff85f65d2ff@o4508981889859584.ingest.de.sentry.io/4508981894774864",
    integrations: [
        Sentry.browserTracingIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/booking\.pegasuspole\.de/],
    environment: process.env.NODE_ENV
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <ContextProvider>
            <CartProvider>
                <CookieConsentProvider>
                    <RouterProvider router={router} />
                </CookieConsentProvider>
            </CartProvider>
        </ContextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
